<template>
  <div>
    <div class="row">
      <div class="col-lg-6 title-col">
        <h4 class="edit-action-text">{{ $t("Edit action") }}</h4>
        <h1>{{ actionData.title }}</h1>
      </div>
    </div>
    <div class="row">
      <!-- Column 1 Actions edit: Repair machine-->
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="form-horizontal p-t-20">
              <div class="form-group row">
                <label for="action-title" class="col-sm-12 control-label">{{ $t("Action title") }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <input type="text" v-model="actionData.title" class="form-control btn-rounded" id="action-title">

                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="action-title" class="col-sm-12 control-label">{{ $t("Description") }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <textarea v-model="actionData.description" class="form-control" rows="5"></textarea>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="action-title" class="col-sm-6 control-label">{{ $t("Start date") }}</label>
                <label for="action-title" class="col-sm-6 control-label">{{ $t("Due date") }}</label>
              </div>

              <div class="form-group row">
                <div class="col-sm-6">
                  <div class="input-group">
                    <datetime v-model="actionData.date_start" type="date" format="DateTime.DATE_MED" class="form-control btn-rounded"></datetime>
                    <div class="input-group-addon"><i class="ti-calendar"></i></div></div>
                </div>
                <div class="col-sm-6">
                  <div class="input-group">
                    <datetime v-model="actionData.date_end" type="date" format="DateTime.DATE_MED" class="form-control btn-rounded"></datetime>
                    <div class="input-group-addon"><i class="ti-calendar"></i></div></div>
                </div>
              </div>


              <div class="form-group row">
                <label for="owner" class="col-sm-12 control-label">{{ $t("Owner") }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <select id="owner" class="form-control btn-rounded action-owner" v-model="actionData.Owner">
                      <option v-bind:value="actionData.Owner" selected="selected">
                        {{ actionData.Owner.firstname }} {{ actionData.Owner.lastname }}
                      </option>
                      <option v-for="user in users" v-bind:value="user" v-if="!(user.uid === actionData.Owner.uid)">
                        {{ user.firstname }} {{ user.lastname }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="action-kpi" class="col-sm-12 control-label">{{ $t("Related KPI") }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <select id="action-kpi" class="form-control btn-rounded action-kpi" v-model="actionData.Kpi" v-on:change="updateKpi">
                      <option v-bind:value="actionData.Kpi" selected="selected">
                        {{ actionData.Kpi.name }}
                      </option>
                      <option v-for="kpi in kpis" v-bind:value="kpi" v-if="!(kpi.uid === actionData.Kpi.uid)">
                        {{ kpi.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="problem" class="col-sm-12 control-label">{{ $t("Related problem") }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <select id="problem" class="form-control btn-rounded action-problem" v-model="actionData.KpiProblemCause">
                      <option v-bind:value="actionData.KpiProblemCause" selected="selected">
                        {{ actionData.KpiProblemCause.name }}
                      </option>
                      <option v-for="problem in problems" v-bind:value="problem" v-if="!(problem.uid === actionData.KpiProblemCause.uid)">
                        {{ problem.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contribution" class="col-sm-12 control-label">{{ $t("% Contribution to solution (0-100%)") }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <select id="contribution" class="form-control btn-rounded action-problem" v-model="actionData.kpi_contribution">
                      <option v-for="percentage in percentages" v-bind:value="percentage">
                        {{ percentage }}%
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="form-group row m-b-0">
                <div class="offset-sm-12 col-sm-12 pull-right">
                  <button type="button" class="btn btn-rounded btn-info" v-on:click="saveChanges()">{{ $t("Save changes") }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- / Column 1 Actions edit: Repair machine-->


      <!-- Column 2 Actions edit: Status-->
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div>

              <h3 class="card-title">{{ $t("Status") }}</h3>

              <div class="row">
                <div class="col-4">
                  <i class="ti-more-alt  p-r-10 text-info"></i>{{ $t(actionData.status) | ucFirst }}
                </div>
                <div class="col-8 text-right" v-show="actionData.status === 'accept'">
                  <button type="button" class="btn btn-success btn-rounded p-r-10"><i class="ti-check"></i> {{ $t("Accept") }}</button>
                  <button type="button" class="btn btn-danger btn-rounded"><i class="ti-close"></i> {{ $t("Decline") }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div>
                <h3 class="card-title">{{ $t("Activity") }}</h3></div>
              <div class="ml-auto">
                <button type="button" class="btn btn-rounded btn-info" data-toggle="modal" data-target="#modalNote"><i class="ti-plus"></i> {{ $t("Add note") }}</button>

              </div>
            </div>
          </div>

          <!-- Add NOTE modal content -->
          <div id="modalNote" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title" id="myModalLabel">{{ $t("Add note") }}</h3>
                  <div class="pull-right">
                    <button type="button" class="close p-l-20 p-t-5 text-info" data-dismiss="modal" aria-hidden="true"><i class="ti-close"></i></button>
                  </div>

                </div>
                <div class="modal-body">
                  {{ $t("Related action") }} <span class="text-muted">{{ actionData.title }}</span>

                  <div class="m-t-20">

                    <div class="form-group row">
                      <label class="col-sm-12 control-label">{{ $t("Note") }}</label>
                      <div class="col-sm-12">
                        <div class="input-group">
                          <textarea v-model="note" class="form-control" rows="5" :placeholder="$t('Leave note here')"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row m-b-0">
                      <div class="offset-sm-12 col-sm-12 pull-right">
                        <button class="btn btn-sm btn-rounded btn-info" data-toggle="modal" data-target="#modalNote" v-on:click="addNote()" >{{ $t("Add note") }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </div>
          <!-- /.modal -->


          <!-- ============================================================== -->
          <!-- Activity widgets -->
          <!-- ============================================================== -->
          <div class="table-responsive">
            <table class="table vm no-th-brd pro-of-month">
              <tbody>
              <tr v-for="log in actionData.ActionLogs.data">
                <td style="vertical-align: top;">
                  <div class="p-2 m-t-0">{{ log.timestamp | formatDate }}</div>
                </td>
                <td>
                  <h5 class="p-t-10">
                    {{ log.User.firstname }} {{ log.User.lastname}}
                  </h5>
                  <br/>
                  <p v-if="log.note !== null">
                    {{ log.note }}
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div></div>
</template>

<script>
  import APIHelper from "../mixins/APIHelper"
  export default {
    name: "edit-action",
    data: function () {
      return {
        actionData: {},
        users: [],
        kpis: [],
        problems: [],
        percentages: [],
        note: "",
        userData: APIHelper.getUserData()
      }
    },
    created() {
      this.loadAction();
    },
    methods: {
      loadAction: function () {
        let vm = this;
        let actionId = this.$route.params.id;
        let args = {
          "include": "Owner,Creator,Kpi,KpiProblemCause,MeetingSource,ActionLogs"
        };
        APIHelper.getResource("/api/action/" + actionId, args).then((data) => {
          vm.actionData = data;
          this.$parent.$emit("addTitleBreadcrumb", vm.actionData.title);
          if(vm.actionData.date_start === null){
            vm.actionData.date_start = moment().format();
          }

          if(vm.actionData.date_end === null){
            vm.actionData.date_end = moment().format();
          }

          vm.loadProblems();
          vm.loadUsers();
          vm.loadKPISForUser();
          vm.generatePercentages();

        });
      },
      updateKpi: function () {
        let vm = this;
        vm.loadProblems();
      },
      addNote: function () {
        let data = {
          status: this.actionData.status,
          message: this.note,
        };
        let vm = this;
        APIHelper.patchResource("/api/action/" + this.$route.params.id, data).then(function () {
          data.timestamp = moment();
          data.User = {
            firstname: vm.userData.firstname,
            lastname: vm.userData.lastname
          };
          data.note = data.message;
          vm.actionData.ActionLogs.push(data);
          vm.$notify({
            group: "notification",
            title: vm.$t("Success"),
            text: vm.$t("Note added successfully"),
            type: "success"
          })
        });

      },
      loadUsers: function () {
        let vm = this;
        APIHelper.getResource("/api/user").then((data) => {
          vm.users = data.data;
        });
      },
      loadKPISForUser: function () {
        let vm = this;
        APIHelper.getResource("/api/user/{uid}/kpi").then((data) => {
          vm.kpis = data;
        });
      },
      loadProblems: function () {
        let vm = this;
        let startDate = moment().subtract(1, "year").format("YYYY-M-DD");
        let endDate = moment().add(1, "year").format("YYYY-M-DD");
        let data = {"date_start": startDate, "date_end": endDate};

        APIHelper.getResource("/api/kpi/" + vm.actionData.Kpi.uid + "/problem", data)
          .then((data) => {
            vm.problems = data;
          });
      },
      generatePercentages: function () {
        for(let i = 0; i <= 100; i += 10){
          this.percentages.push(i);
        }
      },
      saveChanges: function () {
        let vm = this;
        let actionId = this.$route.params.id;

        let kpiProblemCause = vm.actionData.KpiProblemCause.kpi_problem_cause_id;
        kpiProblemCause = kpiProblemCause ? undefined : vm.actionData.kpi_problem_cause;

        let data_to_send = {
          "owner_uid" : vm.actionData.Owner.uid,
          "kpi_uid" : vm.actionData.Kpi.uid,
          "kpi_problem_cause_id" : kpiProblemCause,
          "kpi_contribution" : vm.actionData.kpi_contribution,
          "title" : vm.actionData.title,
          "description" : vm.actionData.description,
          "date_start" : vm.actionData.date_start,
          "date_end" : vm.actionData.date_end
        };

        APIHelper.putResource("/api/action/" + actionId, data_to_send).then((data) => {
          if(data.status === 409){
            vm.$notify({
              group: "notification",
              title: vm.$t("Could not save changed"),
              text: data.title["validateField"],
              type: 'error'
            });
          }else {
            vm.$notify({
              group: "notification",
              title: vm.$t("Success"),
              text: vm.$t("Action saved successfully"),
              type: 'success'
            });
            this.$router.push("/action/" + actionId);
          }
        });


      }
    },
    beforeDestroy(){
      this.$parent.$emit("removeTitleBreadcrumb");

    }
  }
</script>

<style scoped>
  .edit-action-text{
    color: #68768e;
  }

  .title-col{
    margin-bottom: 50px;

  }
</style>



// WEBPACK FOOTER //
// src/components/EditAction.vue